import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../../../components/loader/Loader";
import {
  markPrizeAsDelivered,
  unmarkPrizeAsDelivered,
} from "../../../../../features/prizeDelivery/prizeDeliverySlice";
import OneWinner from "./oneWinner/OneWinner";
import styles from "./winnersList.module.css";

const WinnersList = ({ selectedTournament }) => {
  const dispatch = useDispatch();

  const {
    tournamentsWithPrizeStatus,
    fetchPrizeStatusStatus,
    toggleWinnerStatus,
  } = useSelector((state) => state.prizeDelivery);

  const handleTogglePrize = useCallback(
    (userId, tableId, currentStatus) => {
      if (currentStatus) {
        dispatch(
          unmarkPrizeAsDelivered({
            userId,
            tableId,
            tournamentId: selectedTournament,
          })
        );
      } else {
        dispatch(
          markPrizeAsDelivered({
            userId,
            tableId,
            tournamentId: selectedTournament,
          })
        );
      }
    },
    [dispatch, selectedTournament]
  );

  const selected = tournamentsWithPrizeStatus.find(
    (item) => item._id === selectedTournament
  );

  const displayWinners = selected?.prizeStatuses?.map((item) => (
    <OneWinner
      key={item.userId}
      winner={item}
      handleTogglePrize={handleTogglePrize}
    />
  ));

  return (
    <div className={styles.container}>
      {fetchPrizeStatusStatus === "loading" ? (
        <div className={styles.loaderContainer}>
          <Loader />
        </div>
      ) : toggleWinnerStatus === "loading" ? (
        <div className={styles.loaderContainer}>
          <Loader />
        </div>
      ) : (
        <div className={styles.winnerListWrapper}>{displayWinners}</div>
      )}
    </div>
  );
};

export default WinnersList;
